// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"655":"3b53517f","818":"3b53517f","1640":"3b53517f","2276":"3b53517f","2666":"3b53517f","3240":"3b53517f","8437":"3b53517f","8753":"3b53517f"}[chunkId] + ".chunk.css";
};